// extracted by mini-css-extract-plugin
export var baseButton = "_pt-0";
export var controlsArrowKeys = "_pt-1";
export var controlsResetButton = "_pt-2";
export var lightGameButton = "_pt-4 _pt-0";
export var playAgainButton = "_pt-5 _pt-0";
export var startGameButton = "_pt-3 _pt-0";